import React from 'react';
import './style.scss';
import Translation from 'services/translation.service';
import Button from 'components/ui_elements/Button';
import RadioButton from 'components/ui_elements/RadioButton';

import { getStorageElement, setStorageElement } from 'services/storage.service';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { switchAccount } from 'stores/User/userActions';
import { initialUserDashboard } from 'stores/Dashboard/dashboardActions';
import { Link, withRouter } from 'react-router-dom';

import * as constants from '../../../../../constants';
import { urlFormatter } from '../../../../../util';
import { getUserLogin } from 'services/user.service';

const SubscribersList = (props) => {
  const [subAccountId, changeSubAccountId] = React.useState(null);
  const [storageSubAccountId, changeStorageSubAccountId] = React.useState(null);
  const [isDisabled, changeDisabled] = React.useState(true);
  const {
    initialUserDashboard,
    switchAccount,
    subAccountsList,
    showSubscribersAccountsModal,
    toggleNav,
    history,
    links,
  } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [userPermissions, setUserPermissions] = React.useState([]);
  React.useEffect(() => {
    const subAccount = getStorageElement('subAccountId');
    changeStorageSubAccountId(subAccount);
  }, []);

  const updateSubAccountId = React.useCallback((subAccountId) => {
    changeSubAccountId(subAccountId);
    changeDisabled(false);
  }, []);

  const toggleSideNav = () => {
    if (window.innerWidth <= 1025) {
      toggleNav();
    }
  };

  const fetchPermissions = async () => {
    try {
      setIsLoading(true);
      // Fetch permissions from the endpoint
      const response = await getUserLogin();
      const permissions = response?.data?.accessList || []; // Extract access_list from the first object

      // Remove old local storage and update with new permissions
      localStorage.removeItem('userPermissions');
      localStorage.setItem('userPermissions', JSON.stringify(permissions));

      setUserPermissions(permissions);
    } catch (error) {
      console.error('Error fetching permissions:', error);
      setUserPermissions([]); // Fallback to an empty list
    } finally {
      setIsLoading(false);
    }
  };

  const switchAccountUser = async () => {
    setStorageElement('subAccountId', subAccountId); // Save the selected account ID
    showSubscribersAccountsModal(false); // Close the modal
    switchAccount(subAccountId); // Switch the account
    initialUserDashboard(subAccountId); // Initialize the dashboard for the new account
    toggleSideNav(); // Toggle the side navigation

    // Fetch and update permissions
    await fetchPermissions();

    // Redirect to the dashboard usage route
    history.push(urlFormatter(links['wsc-dashboard-usage']['route']));
    window.location.reload();

  };

  const closeSwitchAccount = () => {
    let closeModal = document.getElementById('modal-close');
    closeModal.click();
    toggleSideNav();
  };

  const mainSubscriberAccount = [];
  const otherSubscribersAccounts = [];
  if (subAccountsList) {
    subAccountsList.forEach((subscriber) => {
      const subscriptionType = subscriber.user.properties.subscription_type;
      let balanceAmount = 0;
      let subscriptionTypeLabel = '';
      if (subscriptionType === constants.PREPAID) {
        subscriptionTypeLabel = Translation.key('generic_balance_lbl1.0');
        balanceAmount =
          subscriber.user.balance_details.main.amount.value +
          ' ' +
          Translation.key(subscriber.user.balance_details.main.amount.currency);
      } else {
        subscriptionTypeLabel = Translation.key('generic_due_balance_lbl1.0');
        balanceAmount =
          subscriber.user.balance_details.outstanding.amount.value +
          ' ' +
          Translation.key(
            subscriber.user.balance_details.outstanding.amount.currency
          );
      }

      const subscriberName = subscriber.nickname;

      let checked = false;

      if (storageSubAccountId) {
        if (subAccountId && subscriber.subscription_id == subAccountId) {
          checked = true;
        }
        if (
          !subAccountId &&
          storageSubAccountId == subscriber.subscription_id
        ) {
          checked = true;
        }
      } else {
        if (!subAccountId && subscriber.user.is_main) {
          checked = true;
        } else if (
          subAccountId &&
          subscriber.subscription_id == subAccountId
        ) {
          checked = true;
        }
      }

      const subAccountContent = (
        <div className="subscriberRow" key={subscriber.user.id}>
          <div className="subscriberRowPart1">
            <RadioButton
              name="subscriber"
              id={subscriber.user.id}
              checked={checked ? 'checked' : false}
              value={subscriber.subscription_id}
              action={() => updateSubAccountId(subscriber.subscription_id)}
            />
          </div>
          <div className="subscriberRowPart2">
            <div className="subscriberInfo">
              <div className="subscriberCellTitle bold">
                {subscriberName.trim()
                  ? subscriberName
                  : subscriber.user.mobile_number}
              </div>
              <div className="greyTxt">{subscriber.user.mobile_number}</div>
            </div>
            <div className="subscriberBalanceInfo">
              <div className="subscriberCellTitle greyTxt">
                {subscriptionTypeLabel}
              </div>
              <div className="bold">{balanceAmount}</div>
            </div>
          </div>
        </div>
      );
      if (subscriber.user.is_main) {
        mainSubscriberAccount.push(subAccountContent);
      } else {
        otherSubscribersAccounts.push(subAccountContent);
      }
    });
  }
  let otherSubscribersAccountsBlock = null;
  if (otherSubscribersAccounts.length) {
    otherSubscribersAccountsBlock = (
      <div className="otherSubscribersAccountsBlock">
        <div className="blockSubscribeTitle otherSubscribeTitle">
          {Translation.key('Switch_account1.0_lbl1.3_other_accounts')}
        </div>
        <div className="subscriberRowContainer">{otherSubscribersAccounts}</div>
      </div>
    );
  }
  return (
    <>
      <div className="switchAccountTitleContainer">
        <h2 className="switchAccountTitle">
          {Translation.key('switch_account1.0_lbl1.0_switch_account')}
        </h2>
        <Link
          className="addAccountLink"
          to={urlFormatter('/dashboard/add-account')}
          onClick={() => {
            closeSwitchAccount();
          }}
        >
          {Translation.key('switch_account1.0_lbl1.1_add_account')}
        </Link>
      </div>
      <div className="blockSubscribeTitle mainAccount">
        {Translation.key('Switch_account1.0_lbl1.2_main_account')}
      </div>
      {mainSubscriberAccount[0]}
      {otherSubscribersAccountsBlock}
      <div className="subscribeOptions">
        <div>
          <button
            className="lebara-button primary"
            style={{ display: 'block' }}
            onClick={switchAccountUser}
            disabled={isDisabled}
          >
            {Translation.key('switch_account1.0_lbl1.0_switch_account')}
          </button>
        </div>
        <div>
          <button
            className="lebara-button"
            style={{ display: 'block' }}
            onClick={showSubscribersAccountsModal}
          >
            {Translation.key('generic_btn_value_cancel')}
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    subscribersList: state.user.subscribersList,
    links: state.layout.routes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ switchAccount, initialUserDashboard }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SubscribersList));
